module.exports = __webpack_public_path__ + "a9bbcfa0043615f7612645c06e24b030.svg";